import React from 'react';
import './PageLoader.scss'; // Import the CSS file for styling

const PageLoader: React.FC = () => {
  return (
    <div className='spinner-container'>
      <div className='spinner'></div>
    </div>
  );
};

export default PageLoader;
